<template>
  <div class="beneficiaries-container s-pt-4 s-flex s-flex-col s-gap-4">
    <div
      class="beneficiary-item s-pb-2"
      v-for="item in filteredBeneficiaries"
      :key="item.index"
    >
      <div class="column-name">
        <div class="beneficiary-name s-text-left s-cursor-pointer" @click="() => editAction(item.index)">
          {{ item.beneficiary.firstName.value }}&nbsp;{{ item.beneficiary.lastName.value }}
        </div>
        <div class="beneficiary-email fs-mask s-flex s-gap-2 s-items-center">
          {{ item.beneficiary.emailAddress.value }}
        </div>
      </div>
      <div class="column-id s-text-left">
        <div class="tax-id fs-mask">
          {{ $t('beneficiary.taxId') }} -
          {{ maskTaxId(item.beneficiary.taxId.value, item.beneficiary) }}
        </div>
      </div>
      <div class="column-dots dots">
        <c-popover
          :arrow="false"
          v-bind="openOptions"
          :primary-action="(item.isControlPerson || readOnly) ? null : $t('global.action.delete')"
          :secondary-action="$t('global.action.edit')"
          @primary="() => {
            showDeleteConfirmation = true;
            toBeDeletedIndex = item.index;
          }"
          @cancel="() => editAction(item.index)"
        >
          <c-tag class="c-cursor-pointer" slot="trigger">
            <c-icon name="dots-horizontal" size="16" />
          </c-tag>
        </c-popover>
      </div>
    </div>

    <s-modal
      :control-variable="showDeleteConfirmation"
      :primary-action="{
        label: $t('global.action.delete'),
        action: () => deleteOwner(toBeDeletedIndex)
      }"
      :secondary-action="{
        label: $t('global.action.dismiss'),
        action: () => {
          showDeleteConfirmation = false;
          toBeDeletedIndex = undefined;
        }
      }"
      :heading="$t('addBeneficiary.shouldDeleteBeneficiary')"
      size="small"
      :dismissable="false"
      class="s-text-left"
      action-variant="danger"
    >
      <template #body>
        <div class="s-text-left">
          {{ $t('addBeneficiary.shouldDeleteBeneficiaryDescription') }}
        </div>
      </template>
    </s-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {maskTaxId} from "@/app/utils/common/functions/functions";

export default {
  name: "BeneficiariesList",
  props: {
    editAction: {
      type: Function,
      required: true,
    },
    deleteAction: {
      type: Function,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    showControlPerson: Boolean,
    showAdditionalOwners: Boolean,
  },
  data: () => ({
    openOptions: false,
    blockOwnerDelete: false,
    showDeleteConfirmation: false,
    toBeDeletedIndex: undefined
  }),
  computed: {
    ...mapGetters('stakeholdersDetails', [
      'isBeneficiaryValid',
      'getBeneficiaries',
      'getErrors',
    ]),
    // preserve index while filtering. Because currently beneficiaries are uniquely identified by their index
    filteredBeneficiaries() {
      return this.getBeneficiaries
          .map((x, index) => ({index, beneficiary: x, isControlPerson: index === 0}))
          .filter((x) => this.isBeneficiaryValid(x.index))
          .filter(x => {
            if (this.showControlPerson) {
              return x.isControlPerson
            }

            if (this.showAdditionalOwners) {
              return !x.isControlPerson
            }
          })
    },
  },
  methods: {
    maskTaxId: maskTaxId,
    deleteOwner(i) {
      this.deleteAction(i);
    },
  },
}
</script>

<style lang="scss">
.beneficiaries-container {
  width: 100%;

  & .beneficiary-item {

    border-bottom: 1px solid #E5E7EB;

    & .column-name {
      flex: 1 1 50%;
    }

    & .column-id {
      flex: 1 1 45%;
    }

    & .column-dots {
      flex: 1 1 5%;
    }

    & .beneficiary-item-column {
      flex: 1;
    }

    display: flex;
    justify-content: space-between;

    & .beneficiary-name {
      color: $primary-600;
      font-size: 14px;
      font-weight: $weight_medium;
    }

    & .beneficiary-email {
      color: $subtitle-text;
    }

    & .tax-id {
      color: $subtitle-text;
    }

    & .dots {

      & .c-cursor-pointer {
        border: none;
        background: none;
      }

      & .c-popover__footer {
        display: flex;
        flex-direction: column;
        margin-top: 0;
      }

      & .c-popover__wrap {
        min-width: 150px;
        padding: 0;

        display: flex;
        flex-direction: column;
        margin-top: 10px;

        & button {
          background: none;
          width: 100%;
          border: none;
          box-shadow: none;
          border-radius: 0;
          padding: 16px;

          &:hover {
            background-color: $primary_fill_light;
          }

          & .c-button__label {
            display: block;
            text-align: left;
          }
        }

        & .c-button--secondary {
          color: $color_black;
        }

        & .c-button--primary {
          color: $color_red;
        }

        & .c-button--primary:hover {
          background-color: #FEF2F2;
        }

        & button.disabled {
          color: $disablea_text;
          opacity: 0.7;

          &:hover {
            background: none;
          }
        }
      }
    }
  }
}
</style>
